/**
 * UI store — sidebar state and theme preference.
 */

import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface UiState {
  sidebarOpen: boolean;
  themeMode: "light" | "dark";
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setThemeMode: (mode: "light" | "dark") => void;
  toggleTheme: () => void;
}

export const useUiStore = create<UiState>()(
  devtools(
    persist(
      (set) => ({
        sidebarOpen: true,
        themeMode: "light",
        toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
        setSidebarOpen: (open) => set({ sidebarOpen: open }),
        setThemeMode: (mode) => set({ themeMode: mode }),
        toggleTheme: () => set((s) => ({ themeMode: s.themeMode === "light" ? "dark" : "light" })),
      }),
      { name: "stavby-ui" },
    ),
    { name: "UiStore" },
  ),
);
